export type ReactPress = {
  api: {
    nonce: string;
    rest_url: string;
  };
  post: {
    ID: string;
    comment_count: string;
    comment_status: string;
    filter: string;
    guid: string;
    menu_order: string;
    ping_status: string;
    pinged: string;
    post_author: string;
    post_content: string;
    post_content_filtered: string;
    post_date: string;
    post_date_gmt: string;
    post_excerpt: string;
    post_mime_type: string;
    post_modified: string;
    post_modified_gmt: string;
    post_name: string;
    post_parent: string;
    post_password: string;
    post_status: string;
    post_title: string;
    post_type: string;
    to_ping: string;
  };
  caps: {
    administrator: boolean;
  };
  user: {
    ID: number;
    roles: string[];
    data: {
      ID: string;
      display_name: string;
      user_activation_key: string;
      user_email: string;
      user_login: string;
      user_nicename: string;
      user_registered: string;
      user_status: string;
      user_url: string;
    };
  };
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const reactPress: ReactPress = window.reactPress;

export default reactPress;
